<template>
  <div>
    <div v-if="info" class="bodyConts">
      <div class="headThem">
        云南省建设工程材料及设备信息登记卡
      </div>
      <div class="box-Wrap">
        <div class="boxWrap-T">产品详情</div>
      </div>
      <div class="productTop">
        <img
          @click="showQrCode = true"
          src="~@/assets/bluescan.png"
          class="code-img"
        />
        <ListDetailCont>
          <div class="product-p">
            <div class="product-T">{{ info.product_name }}</div>
            <div class="product-child">
              <span class="location"> 产地</span>:
              <div class="location-T">{{ info.product_address }}</div>
            </div>
            <div class="product-child">
              <span class="location"> 产品分类</span>:
              <div class="location-T">{{ info.product_cate }}</div>
            </div>
            <div class="product-child">
              <span class="location"> 生产厂商</span>：
              <div class="location-T location-T-add">
                {{ info.company_name }}
              </div>
            </div>
            <div class="product-child" v-if="info.agent_name">
              <span class="location"> 代理商</span>：
              <div class="location-T location-T-add">
                {{ info.agent_name }}
              </div>
            </div>
            <div class="product-child">
              <span class="location locationadd">编码标识有效期</span>：
              <div class="location-T location-T-add">
                {{ info.codetime }} 至 {{ info.codevalidtime }}
                <span v-if="info.has_expired == 1">（已过期）</span>
              </div>
            </div>
            <!--            <div-->
            <!--              class="marginTop15"-->
            <!--              style="text-align: right; font-size: 14px; color: #666666"-->
            <!--            >-->
            <!--              云南省住房和城乡建设厅-->
            <!--            </div>-->
          </div>
        </ListDetailCont>
      </div>
      <div class="blue-T">基本参数</div>
      <div class="bodycontain">
        <ListDetailCont>
          <div class="box-cont">
            <div v-if="info.mspec" class="box-item">
              <div class="box-title">规格型号</div>
              <div class="box-detail">{{ info.mspec }}</div>
            </div>
            <div v-if="info.munit" class="box-item">
              <div class="box-title">计量单位</div>
              <div class="box-detail">{{ info.munit }}</div>
            </div>
            <div v-if="info.wpu" class="box-item">
              <div class="box-title">单位重量</div>
              <div class="box-detail">{{ info.wpu }}</div>
            </div>
            <div v-if="info.shape" class="box-item">
              <div class="box-title">外形尺寸</div>
              <div class="box-detail">{{ info.shape }}</div>
            </div>
            <div v-if="info.reportno" class="box-item">
              <div class="box-title">检测报告编号</div>
              <div class="box-detail">{{ info.reportno }}</div>
            </div>
            <div v-if="info.exec_standard" class="box-item">
              <div class="box-title">产品执行标准</div>
              <div class="box-detail">{{ info.exec_standard }}</div>
            </div>
            <div v-if="info.product_code" class="box-item">
              <div class="box-title">标准号</div>
              <div class="box-detail">{{ info.product_code }}</div>
            </div>
            <!-- <div class="box-item">
              <div class="box-title">设计产能</div>
              <div class="box-detail">{{ info.design_mount }}</div>
            </div> -->
          </div>
        </ListDetailCont>
      </div>
    </div>
    <el-dialog title="编码标识" :visible.sync="showQrCode" width="90%">
      <div>
        <el-image
          v-if="info"
          style="width: 100%;"
          :src="'data:image/jpg;base64,' + info.cert_link"
        ></el-image>
        <div style="text-align: center;" class="marginTop20">
          长按二维码图片可以保存到相册
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQrCode = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "@/plugins/axios.js";
import ListDetailCont from "@/components/ListDetailCont";
export default {
  components: {
    ListDetailCont
  },
  data() {
    return {
      showQrCode: false, // 显示二维码模态框
      info: null
    };
  },
  async mounted() {
    this.info = await Api.speciDetail(
      this.$store.state.token,
      this.$route.query.uuid
    );
  }
};
</script>
<style lang="less" scoped>
.footTip {
  padding: 10px;
  font-size: 13px;
  background: #fff;
  margin-top: 20px;
  color: #666;
  line-height: 20px;
}
.bodyConts {
  background-color: rgb(245, 245, 245);
  min-height: calc(100vh - 167px);
  padding-bottom: 50px;
  .headThem {
    height: 30px;
    background: rgba(0, 130, 164, 1);
    display: flex;
    padding: 7px 25px;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 1);
  }
  .box-Wrap {
    background-image: url("~@/assets/heads.png");
    background-size: 100% 100%;
    height: 137px;
    background-repeat: no-repeat;
    width: 100vw;
    box-sizing: border-box;
    //padding-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .boxWrap-T {
      font-size: 22px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
  }
  .productTop {
    margin-top: -53px;
    margin-right: 17px;
    margin-left: 17px;
    position: relative;
    .code-img {
      width: 17px;
      height: 17px;
      position: absolute;
      right: 10px;
      top: 15px;
    }
    .product-p {
      padding: 15px 23px;

      .product-T {
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .product-child:first-child {
        margin-top: 0px;
      }
      .product-child {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: rgba(51, 51, 51, 1);
        margin-top: 15px;
        .location {
          min-width: 70px;
          text-align-last: justify;
          text-align: justify;
          word-break: break-all;
          text-justify: inter-ideograph;
          width: 4.4rem;
          display: inline-block;
          vertical-align: top;
        }

        .location:after {
          display: inline-block;
          content: "";
          overflow: hidden;
          width: 100%;
          height: 0;
        }

        .locationadd {
          text-align: left;
          width: 100px;
        }
        .location-T {
          margin-left: 15px;
        }
        .location-T-add {
          margin-left: 2px;
        }
      }
    }
  }
  .blue-T {
    font-size: 17px;
    padding: 15px 20px 0;
    font-weight: bold;
    color: rgba(13, 86, 129, 1);
  }
  .bodycontain {
    margin: 0px 17px 0 17px;
    .box-cont {
      padding: 0 25px;
    }
    .box-item {
      padding: 15px 0;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      .box-title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 130, 164, 1);
      }
      .box-detail {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
    .box-item:last-child {
      border-bottom: none;
    }
  }
}
</style>
